import { jsx as _jsx } from "react/jsx-runtime";
import { NodeToolbar, Position } from "@xyflow/react";
import React, { useEffect, useRef, useState } from "react";
import "./NodeToolBarWrapper.css";
/**
 * Choose which side of the node the tooltip sits on so it stays inside the diagram container.
 * Prefers the right; when the right side would overflow the container's right edge it flips to
 * the left, and when the left side would overflow the left edge it flips back to the right. If
 * neither side fully fits, the side with more room wins.
 */
export const resolveToolTipPosition = (nodeRect, containerRect, tooltipWidth, offset) => {
    const requiredWidth = tooltipWidth + offset;
    const spaceOnRight = containerRect.right - nodeRect.right;
    const spaceOnLeft = nodeRect.left - containerRect.left;
    if (spaceOnRight >= requiredWidth) {
        return Position.Right;
    }
    if (spaceOnLeft >= requiredWidth) {
        return Position.Left;
    }
    return spaceOnRight >= spaceOnLeft ? Position.Right : Position.Left;
};
const NodeToolbarWrapper = (props) => {
    const { align, children, className, isVisible, nodeId, offset, position, ...rest } = props;
    const nodeToolBarRef = useRef(null);
    const [newPosition, setNewPosition] = useState(position ?? Position.Right);
    const adjustToolTipPosition = (wrapper) => {
        // The wrapper lives inside the React Flow node, but the tooltip itself is portaled into
        // the renderer (position:fixed). Measure the node + diagram container from the DOM and
        // read the portaled tooltip's width so we can flip the side on overflow.
        const nodeElement = wrapper.closest(".react-flow__node") ?? wrapper.parentElement;
        const containerElement = wrapper.closest(".react-flow");
        if (!nodeElement || !containerElement) {
            return;
        }
        const nodeRect = nodeElement.getBoundingClientRect();
        const containerRect = containerElement.getBoundingClientRect();
        const tooltipElement = containerElement.querySelector("[aria-label='network-diagram-tooltip']");
        const tooltipWidth = tooltipElement?.getBoundingClientRect().width ?? 0;
        setNewPosition(resolveToolTipPosition(nodeRect, containerRect, tooltipWidth, offset ?? 0));
    };
    useEffect(() => {
        if (nodeToolBarRef.current && isVisible) {
            adjustToolTipPosition(nodeToolBarRef.current);
        }
    }, [isVisible, position, offset, align]);
    return (_jsx("div", { className: "toolbar-wrapper", "data-test": "node-toolbar", ref: nodeToolBarRef, children: _jsx(NodeToolbar, { className: className, isVisible: isVisible, nodeId: nodeId, offset: offset, position: newPosition, ...rest, children: children }) }));
};
export default NodeToolbarWrapper;
